/* libs */
import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import { Scope, asField } from "informed";

import ValidateItem from "../../../helpers/validation/validateInput";
import GetItem from "../../../helpers/dataProviders/getItem";
import { SelectInput, CollectionAccordion, TextAndValueArray } from "./index";
import Loader from "../../ui/Loader";
import Switcher from "../../ui/Switcher";
import validatehoc from "../Validator";

class DestinationPicker extends Component {
	constructor(props) {
		super(props);
		this.state = {
			type: this.initialSetup(props),
			minimizePlaceholder: false,
			experienceOptions: [],
			integrationOptions: [],
			pageOptions: [],
			sessionOptions: [],
			loadingPages: false,
			showAdvanced: false,
		};
	}

	initialSetup = props => {
		let { value } = props.fieldState;
		if (value) {
			if (value.experienceId) {
				GetItem(`/experiences/${value.experienceId}/pages`).then(data => {
					let pageOptions = [];
					data.data.forEach(page => {
						pageOptions.push({ key: page.id, value: page.id, label: page.name });
					});
					this.setState({ pageOptions, loadingPages: false });
				});
				return "page";
			} else if (value.sessionId) {
				return "session";
			} else if (value.providerId) {
				return "provider";
			}
		}
		return "none";
	};

	componentDidMount() {
		if (this.props) {
			GetItem(`/apps/${this.props.appKey}/experiences`).then(data => {
				let experienceOptions = [];
				data.data.forEach(experience => {
					experienceOptions.push({ key: experience.id, value: experience.id, label: experience.name });
				});
				this.setState({ experienceOptions });
			});
			GetItem(`/apps/${this.props.appKey}/sessions`).then(data => {
				let sessionOptions = [];
				data.data.forEach(session => {
					sessionOptions.push({ key: session.id, value: session.id, label: session.title });
				});
				this.setState({ sessionOptions });
			});
			GetItem(`/apps/${this.props.appKey}/integrations`).then(data => {
				let integrationOptions = [];
				data.data.forEach(integration => {
					integrationOptions.push({ key: integration.id, value: integration.id, label: integration.name });
				});
				this.setState({ integrationOptions });
			});
		}
	}

	validate = value => {
		const { placeholder, isRequired, validationRegex, minLength, maxLength, regexMessage } = this.props;
		if (value && value.length > 0) {
			this.setState({
				minimizePlaceholder: true,
			});
		} else {
			this.setState({
				minimizePlaceholder: false,
			});
		}
		return ValidateItem(value, placeholder, isRequired, validationRegex, minLength, maxLength, regexMessage);
	};

	onFocus = () => {
		this.setState({
			minimizePlaceholder: true,
		});
	};

	onBlur = value => {
		if (!value || value.length < 1) {
			this.setState({
				minimizePlaceholder: false,
			});
		}
	};

	changeExperience = e => {
		let value = e.target.value;
		if (value !== "") {
			this.setState({ loadingPages: true });
			GetItem(`/experiences/${value}/pages`).then(data => {
				let pageOptions = [];
				data.data.forEach(page => {
					pageOptions.push({ key: page.id, value: page.id, label: page.name });
				});
				this.setState({ pageOptions, loadingPages: false });
			});
		} else {
			this.setState({ pageOptions: [] });
		}
	};

	changeSelect = (ref, e) => {
		let newValue = Object.assign({}, this.props.fieldState.value);
		newValue[ref] = e.target.value;
		this.props.fieldApi.setValue(newValue);
		this.props.fieldApi.setTouched(true);
	};

	changeType = (index, option) => {
		this.setState({ type: option.value });
	};

	toggleAdvanced = () => {
		this.setState({ showAdvanced: !this.state.showAdvanced });
	};

	render() {
		const { fieldState } = this.props;
		const { value } = fieldState;
		if (value) {
			//const {pageId, experienceId, sessionId, providerId, pageData} = value;
		}
		const { experienceOptions, pageOptions, sessionOptions, integrationOptions } = this.state;

		const switcherOptions = [
			{ label: "None", value: "none" },
			{ label: "Page", value: "page" },
			{ label: "Session", value: "session" },
			{ label: "Integration", value: "integration" },
		];
		return (
			<Fragment>
				<Scope scope="destination">
					<Switcher initialValue={this.state.type} options={switcherOptions} onSelect={this.changeType} />
					<div className="switcher-well">
						{this.state.type === "none" && <div>{"Don't link to anything"}</div>}
						{this.state.type === "page" && (
							<div>
								{experienceOptions.length > 0 && (
									<SelectInput
										field="experienceId"
										id="experienceId"
										placeholder="Experience"
										values={experienceOptions}
										onChange={e => {
											this.changeExperience(e);
										}}
									/>
								)}
								{this.state.loadingPages && <Loader />}
								{pageOptions.length > 0 && !this.state.loadingPages ? (
									<SelectInput field="pageId" id="pageId" placeholder="Page" values={pageOptions} />
								) : (
									!this.state.loadingPages && <div className="note">No Pages To Display</div>
								)}
							</div>
						)}
						{this.state.type === "session" && (
							<div>
								{sessionOptions.length > 0 && (
									<SelectInput
										field="sessionId"
										id="sessionId"
										placeholder="Session"
										values={sessionOptions}
									/>
								)}
							</div>
						)}
						{this.state.type === "integration" && (
							<div>
								{integrationOptions.length > 0 && (
									<SelectInput
										field="providerId"
										id="providerId"
										placeholder="Integration"
										values={integrationOptions}
									/>
								)}
							</div>
						)}
						{this.state.type !== "none" && (
							<div className={"destination-extras collection-group"}>
								<CollectionAccordion
									title="Advanced Options"
									toggleCollectionItem={this.toggleAdvanced}
									expanded={this.state.showAdvanced}
								>
									<div className="collection-item-properties">
										<TextAndValueArray field="pageData" id="pageData" placeholder="Page Data" />
									</div>
								</CollectionAccordion>
							</div>
						)}
					</div>
				</Scope>
			</Fragment>
		);
	}
}

DestinationPicker.propTypes = {
	field: PropTypes.string,
	id: PropTypes.string,
	placeholder: PropTypes.string,
	autocomplete: PropTypes.string,
	values: PropTypes.array,
	isRequired: PropTypes.bool,
	minLength: PropTypes.number,
	maxLength: PropTypes.number,
	validationRegex: PropTypes.string,
	regexMessage: PropTypes.string,
	defaultEnabled: PropTypes.bool,
	fieldState: PropTypes.object,
	appKey: PropTypes.string,
	fieldApi: PropTypes.object,
};

const Wrapper = validatehoc(
	asField(({ fieldState, ...props }) => <DestinationPicker fieldState={fieldState} {...props} />),
	"object"
);

export default Wrapper;
